export default "__VITE_ASSET__D_razMdO__"